import { Colors } from '../../theme/Colors';
import { Link } from 'react-router-dom';
import { styled } from '@mui/material';

const StyledLink = styled(Link)({
    color: Colors.primary,
    fontFamily: 'Outfit',
    fontSize: 14,
});

export default StyledLink;
